import { EventEmitter, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface IToastMessage {
  message: string, type: 'error' | 'warning' | 'info', duration?: number
}

@Injectable()
export class ToastService {
  private notifications = new EventEmitter()

  constructor (
    private translate: TranslateService
  ) {}

  notify (data: IToastMessage) {
    if (data.message && typeof data.message == 'string') {
      data.message = this.translate.instant(data.message)
    } else if (data.type == 'error' || data.type == 'warning') {
      data.message = 'unknown error'
    } else {
      console.error(data)
      throw new Error('cannot display unknown message: ' + data.message)
    }
    this.notifications.emit(data)
  }
  subscribe (fn: (msg: IToastMessage) => void) {
    this.notifications.subscribe(fn)
  }
}
